import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Utilerias } from "./Utilerias";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class CrudHttp {
  methodGet: string;
  methodPost: string;
  methodPut: string;
  methodDelete: string;
  private http: HttpClient;
  private url: string;
  paramGet: any;

  constructor(http: HttpClient) {
    this.http = http;
    this.url = environment.urlService;
  }

  get() {
    if (this.paramGet) {
      return Utilerias.httpRequest(this.http, this.methodGet, 'get', this.paramGet);
    } else {
      return Utilerias.httpRequest(this.http, this.methodGet, 'get');
    }
  }

  post(obj) {
    return Utilerias.httpRequest(this.http, this.methodPost, 'post', obj);
  }

  put(obj) {
    return Utilerias.httpRequest(this.http, this.methodPut, 'post', obj);
  }

  delete(id) {
    return Utilerias.httpRequest(this.http, this.methodDelete, 'post', id);
  }
}
